export const iconFontAwesomeMusicVideoVolumeHigh = (
	<i className="fa-solid fa-volume-high"></i>
);
